import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    Constants.NHOM_KHACHHANG_LIST_API,
    formData
  )

  return handleRequest(request);
}

function detailRequestApi(formData) {
  const request = axiosApi().post(
    Constants.NHOM_KHACHHANG_DETAIL_API,
    formData
  )

  return handleRequest(request);
}

function nhomKhachHangUpdateRequestApi(formData) {
  const request = axiosApi().post(
    Constants.NHOM_KHACHHANG_UPDATE_API,
    formData
  )

  return handleRequest(request);
}

function nhomKhachHangRemoveRequestApi(formData) {
  const request = axiosApi().post(
    Constants.NHOM_KHACHHANG_REMOVE_API,
    formData
  )

  return handleRequest(request);
}

function* nhomKhachHangListRequestFlow({payload}) {
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.nhomKhachHangListSuccess(results.data))

  } catch (error) {
    yield put(brActions.nhomKhachHangListError(error))
  }
}

function* nhomKhachHangDetailRequestFlow({payload}) {
  try {
    // grab the client from our action
    const results = yield call(detailRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.nhomKhachHangDetailSuccess(results.data))

  } catch (error) {
    yield put(brActions.nhomKhachHangDetailError(error))
  }
}

function* nhomKhachHangUpdateRequestFlow({payload}) {
  try {
    // grab the client from our action
    const result = yield call(nhomKhachHangUpdateRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.nhomKhachHangUpdateSuccess(result));
  } catch (error) {
    yield put(brActions.nhomKhachHangUpdateError(error))
  }
}

function* nhomKhachHangRemoveRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const result = yield call(nhomKhachHangRemoveRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.nhomKhachHangRemoveSuccess(result));
    if (typeof callback == 'function') {
      yield call(callback, result);
    }
  } catch (error) {
    yield put(brActions.nhomKhachHangRemoveError(error))
  }
}

function* nhomKhachHangWatcher() {
  yield [
    takeLatest(Constants.NHOM_KHACHHANG_LIST_REQUESTING, nhomKhachHangListRequestFlow),
    takeLatest(Constants.NHOM_KHACHHANG_DETAIL_REQUESTING, nhomKhachHangDetailRequestFlow),
    takeLatest(Constants.NHOM_KHACHHANG_UPDATE_REQUESTING, nhomKhachHangUpdateRequestFlow),
    takeLatest(Constants.NHOM_KHACHHANG_REMOVE_REQUESTING, nhomKhachHangRemoveRequestFlow),
  ]
}

export default nhomKhachHangWatcher



// WEBPACK FOOTER //
// ./src/views/NhomKhachHang/sagas.js